import { render, staticRenderFns } from "./EdicaoDeFaq.vue?vue&type=template&id=4fc29b19&scoped=true&"
import script from "./EdicaoDeFaq.vue?vue&type=script&lang=ts&"
export * from "./EdicaoDeFaq.vue?vue&type=script&lang=ts&"
import style0 from "./EdicaoDeFaq.vue?vue&type=style&index=0&id=4fc29b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc29b19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardTitle,VCol,VContainer,VRow,VTextField,VTextarea})
